module.exports = __webpack_public_path__ + "static/media/im_folder.dca561e0.svg";